module.exports = __webpack_public_path__ + "img/main-banner-info-users-ua.0c0edfb7.png";